var Keystore = require('./src/keystore');

module.exports = Keystore();